import { render, staticRenderFns } from "./TableSpecimensUnMatch.vue?vue&type=template&id=68126561&scoped=true"
import script from "./TableSpecimensUnMatch.vue?vue&type=script&lang=js"
export * from "./TableSpecimensUnMatch.vue?vue&type=script&lang=js"
import style0 from "./TableSpecimensUnMatch.vue?vue&type=style&index=0&id=68126561&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68126561",
  null
  
)

export default component.exports